export default __webpack_public_path__ + "static/tag-do-3-light-9b308935120cf9937e97d923e9b03488c198d6289b6e1659ed7584fac4cc6b33.png";